@let hiddenByParent = this.parentDisplayed() === false ? true : false;
<button
  mat-icon-button
  [ngClass]="{
    disabled: disabled(),
    'out-of-range': !inResolutionsRange(),
    'visibility-hidden': !visible()
  }"
  [color]="visible() ? 'primary' : 'default'"
  tooltip-position="below"
  matTooltipShowDelay="500"
  [matTooltip]="tooltipText()"
  (click)="toggle($event)"
>
  @let badge = this.badge();
  <igo-icon
    matBadge="icon"
    [igoMatBadgeIcon]="badge ? 'filter_alt' : 'help'"
    [igoMatBadgeInverseColor]="!!badge"
    [igoMatBadgeBackgroundColor]="badge ? '#fff' : null"
    [matBadgeDisabled]="visible() ? (hiddenByParent ? true : false) : true"
    matBadgeColor="accent"
    matBadgeSize="small"
    matBadgePosition="after"
    [matBadgeHidden]="!badge && !showQueryBadge()"
    [icon]="
      visible()
        ? hiddenByParent
          ? eyeClosedByGroupSvg
          : 'visibility'
        : 'visibility_off'
    "
    iconPositionEnd
  />
</button>
